import { render, staticRenderFns } from "./AdminAddNewCategory.vue?vue&type=template&id=f0f5d462&scoped=true&"
import script from "./AdminAddNewCategory.vue?vue&type=script&lang=js&"
export * from "./AdminAddNewCategory.vue?vue&type=script&lang=js&"
import style0 from "./AdminAddNewCategory.vue?vue&type=style&index=0&id=f0f5d462&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f5d462",
  null
  
)

export default component.exports